import useNotifier from '@/hooks/useNotifier';

function Notifier() {
  useNotifier();

  return <></>;
}

export default Notifier;
